import { RouterState } from 'core/utils/router/RouterState';

export default function noApplicationRedirectPromise(rootStore, route) {
    if (!rootStore.applicationStore.applicationExists) {
        return Promise.reject(new RouterState(route));
    }

    return Promise.resolve();
}